// import React from "react";
// import { UseFormRegister, FieldErrors, UseFormSetValue, UseFormWatch, UseFormClearErrors } from "react-hook-form";
// import { OrderFormData } from "../../../types/types";

// interface PaymentSectionProps {
//   register: UseFormRegister<OrderFormData>;
//   errors: FieldErrors<OrderFormData>;
//   setValue: UseFormSetValue<OrderFormData>;
//   watch: UseFormWatch<OrderFormData>;
//   clearErrors: UseFormClearErrors<OrderFormData>;
// }

// const PaymentSection: React.FC<PaymentSectionProps> = ({
//   register,
//   errors,
//   setValue,
//   watch,
//   clearErrors,
// }) => {
//   const paymentType = watch("shipment.paymentType");

//   const handlePaymentTypeChange = (type: "Prepaid" | "COD") => {
//     setValue("shipment.paymentType", type, { shouldValidate: true });
//     clearErrors("shipment.paymentType");

//     if (type !== "COD") {
//       setValue("shipment.codAmount", undefined);
//     }
//   };

//   return (
//     <div className="bg-white p-6 rounded-xl shadow-md">
//       <h2 className="text-xl font-semibold mb-6">Payment Method</h2>

//       <div className="space-y-6">
//         {/* Payment Type Selection */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-3">
//             Select Payment Type
//           </label>
//           <div className="grid grid-cols-2 gap-4">
//             <button
//               type="button"
//               onClick={() => handlePaymentTypeChange("Prepaid")}
//               className={`p-4 rounded-xl border-2 transition-all ${
//                 paymentType === "Prepaid"
//                   ? "border-[#FBD037] bg-yellow-50"
//                   : "border-gray-200 hover:border-gray-300"
//               }`}
//             >
//               <div className="font-medium">Prepaid</div>
//               <div className="text-sm text-gray-500">Pay now</div>
//             </button>

//             <button
//               type="button"
//               onClick={() => handlePaymentTypeChange("COD")}
//               className={`p-4 rounded-xl border-2 transition-all ${
//                 paymentType === "COD"
//                   ? "border-[#FBD037] bg-yellow-50"
//                   : "border-gray-200 hover:border-gray-300"
//               }`}
//             >
//               <div className="font-medium">Cash on Delivery (COD)</div>
//               <div className="text-sm text-gray-500">Pay at delivery</div>
//             </button>
//           </div>
//           {errors.shipment?.paymentType && (
//             <p className="text-red-500 text-sm mt-1">
//               {errors.shipment.paymentType.message}
//             </p>
//           )}
//         </div>

//         {/* COD Amount - shown only when COD is selected */}
//         {paymentType === "COD" && (
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               COD Amount (₹)
//             </label>
//             <input
//               type="number"
//               step="0.01"
//               {...register("shipment.codAmount", {
//                 required: "COD Amount is required",
//                 min: { value: 1, message: "Amount must be greater than 0" },
//               })}
//               className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#FBD037]"
//               placeholder="Enter amount to collect"
//             />
//             {errors.shipment?.codAmount && (
//               <p className="text-red-500 text-sm mt-1">
//                 {errors.shipment.codAmount.message}
//               </p>
//             )}
//           </div>
//         )}

//         {/* Shipment Cost (read-only or editable) */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             Shipment Cost (₹)
//           </label>
//           <input
//             type="number"
//             step="0.01"
//             {...register("shipment.shipmentCost")}
//             className="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50"
//             placeholder="0.00"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentSection;

import React from "react";
import {
  UseFormRegister,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
  UseFormClearErrors,
} from "react-hook-form";
import { OrderFormData } from "../../../types/types";

interface PaymentSectionProps {
  register: UseFormRegister<OrderFormData>;
  errors: FieldErrors<OrderFormData>;
  setValue: UseFormSetValue<OrderFormData>;
  watch: UseFormWatch<OrderFormData>;
  clearErrors: UseFormClearErrors<OrderFormData>;
}

const PaymentSection: React.FC<PaymentSectionProps> = ({
  register,
  errors,
  setValue,
  watch,
  clearErrors,
}) => {
  const paymentType = watch("shipment.paymentType");

  return (
    <div className="bg-white p-8 rounded-2xl shadow-md">
      <h2 className="text-2xl font-semibold mb-2">Payment at Delivery</h2>
      <p className="text-gray-600 mb-8">
        Choose how the delivery agent will collect payment from the receiver
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* COD - Cash */}
        <button
          type="button"
          onClick={() => {
            setValue("shipment.paymentType", "COD", { shouldValidate: true });
            clearErrors("shipment.paymentType");
          }}
          className={`p-6 rounded-2xl border-2 text-left transition-all hover:shadow-md ${
            paymentType === "COD"
              ? "border-[#FBD037] bg-yellow-50"
              : "border-gray-200 hover:border-gray-300"
          }`}
        >
          <div className="font-semibold text-xl mb-1">
            Cash on Delivery (COD)
          </div>
          <div className="text-gray-500">
            Receiver pays in cash to the delivery agent
          </div>
        </button>

        {/* CC - Card on Delivery / POS Machine */}
        <button
          type="button"
          onClick={() => {
            setValue("shipment.paymentType", "CC", {
              shouldValidate: true,
            });
            clearErrors("shipment.paymentType");
          }}
          className={`p-6 rounded-2xl border-2 text-left transition-all hover:shadow-md ${
            paymentType === "CC"
              ? "border-[#FBD037] bg-yellow-50"
              : "border-gray-200 hover:border-gray-300"
          }`}
        >
          <div className="font-semibold text-xl mb-1">
            Card on Delivery (POS Machine)
          </div>
          <div className="text-gray-500">
            Delivery agent will collect payment using Post Machine / POS
            terminal
          </div>
        </button>
      </div>

      {/* Amount Field for both COD and Card */}
      {paymentType === "COD" && (
        <div className="mt-8">
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Amount to Collect (₹)
          </label>
          <input
            type="number"
            step="0.01"
            {...register("shipment.codAmount", {
              required: "Amount is required",
              min: { value: 1, message: "Amount must be greater than ₹1" },
            })}
            className="w-full px-5 py-4 border border-gray-300 rounded-2xl focus:outline-none focus:border-[#FBD037] text-lg"
            placeholder="Enter amount"
          />
          {errors.shipment?.codAmount && (
            <p className="text-red-500 text-sm mt-2">
              {errors.shipment.codAmount.message}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default PaymentSection;
